export function convertBytes(bytes: number) {
  const kilobytes = bytes / 1024;
  const megabytes = kilobytes / 1024;

  return { kilobytes, megabytes };
}
